import { useMemo } from "react";
import * as notify from "shared/notify";
import Modal from "components/modal";
import { isMacOs } from "shared/helpers";

export const CopyPathModal = ({ pathInfo, open, onClose }) => {
    const { networkLocation } = pathInfo;
    const path = useMemo(() => {
        if (isMacOs()) {
            return networkLocation.replaceAll("/", "\\");
        }

        return networkLocation;
    }, [networkLocation]);

    const handleCopy = () => {
        navigator.clipboard
            .writeText(networkLocation)
            .then(() => notify.success("Path copied to clipboard"))
            .catch((err) => notify.error(err.message))
            .finally(onClose);
    };

    return (
        <Modal
            cssClass="bulk-upload-image"
            show={open}
            onClose={onClose}
        >
            <p className="p-t-16 p-l-16 p-r-16 p-b-8 m-0">Your photos can be uploaded to:</p>
            <p className="p-t-8 p-l-16 p-r-16 p-b-8 m-0">
                <strong>{path}</strong>
            </p>

            <p className="p-t-8 p-l-16 p-r-16 p-b-8 m-0">
                Copy and paste the location into your file browser (File Explorer for Windows; Finder for Mac).
            </p>

            <p className="txt-italic p-t-8 p-l-16 p-r-16 p-b-8 m-0">
                Note: This upload location is also available in your Teams channel. You can drag and drop files and/or folders of image files.
            </p>
            <div className="button-group -center p-l-16 p-r-16 m-t-6 m-b-6">
                <button
                    type="button"
                    className="button -primary"
                    onClick={handleCopy}
                >
                    COPY AND CLOSE
                </button>
            </div>
        </Modal>
    );
};
